/**
 * Formats milliseconds into a date string with an apostrophe in the year, in the format "17 Aug ′24 01:05 PM"
 * */
export const formatMillisecondsToDateWithApostrophe = (milliseconds: number) => {
  const date = new Date(milliseconds);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  const formattedDate = formatter.format(date);
  const [day, month, year, time, ampm] = formattedDate.split(' ');

  return `${day} ${month} ′${year} ${time} ${ampm.toUpperCase()}`;
};
